import { render } from "./SampleReportGenPage.vue?vue&type=template&id=effa0516&ts=true"
import script from "./SampleReportGenPage.vue?vue&type=script&lang=ts"
export * from "./SampleReportGenPage.vue?vue&type=script&lang=ts"

import "./SampleReportGenPage.vue?vue&type=style&index=0&id=effa0516&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__